export default {
  LCS_SERVER_NAME: '',
  CAMPAIGNCODE_URL: '',

  ServiceURL: {
    AUTH: 'https://alpha-enterprise-auth.navercorp.com',
    COMMON: 'https://alpha-works-common.navercorp.com',
    NOTIFY: 'https://alpha-notify.navercorp.com',
    BOARD: 'https://alpha-board.navercorp.com',
    TALK: 'https://alpha-talk.navercorp.com',
    MAIL: 'https://alpha-mail.navercorp.com',
    CALENDAR: 'https://alpha-calendar.navercorp.com',
    CONTACT: 'https://alpha-contact.navercorp.com',
    DRIVE: 'https://alpha-ndrive.navercorp.com',
    TASK: 'https://alpha-task.navercorp.com',
    FORM: 'https://alpha-form.navercorp.com',
    TEMPLATE: 'https://alpha-template.navercorp.com',
    ADMIN: 'https://alpha-works-admin.navercorp.com',
    WORKPLACE: '',
    CLOVANOTE: '',
    CSTALK: 'https://alpha-cxtalk.navercorp.com',
  },
};
